// 校园招聘
import React from 'react'
import LxHeader from '@/components/LxHeader/Two'
import styles from './index.module.scss'
import { groceriesList } from '@/constants'
import Groceries from './cmp/Groceries';
import { getDynamicApi } from '@/api'
import defaultSetting from '@/setting'
const pic01 = require("@/assets/images/campus/pic_01.png")
const pic02 = require("@/assets/images/campus/pic_02.png")
const pic03 = require("@/assets/images/campus/pic_03.png")


class CampusRecruitment extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            showList: []
        }
    }

    componentWillMount() {
        if (defaultSetting.grayscale) {
            document.querySelector('html').classList.add('grayscale');
        }
    }

    componentDidMount() {
        getDynamicApi({dynamicKey: 0, pageSize: 5}).then(res => {
            let showList = (res && res.data && res.data.dynamicDetail) || [];
            this.setState({
                showList: showList,
            })
        })
    }

    render() {
        const { showList }  = this.state
        return (
            <>
                <LxHeader></LxHeader>
                <main className={styles.campus}>
                    <div className="banner lx-fz0">
                        {/* <img className="lx-image-rendering" src={bannerImg} alt="banner" /> */}
                    </div>

                    <section className="section-intro lx-flex-row-center">
                        <div className="lx-container lx-flex-row" style={{margin: 0}}>
                            <div className="section-intro-left">
                                <div className="section-intro-top lx-flex-row lx-w100">
                                    <a href={`/positionList?recruitType=1&projectId=205701`} className="section-intro-top-left section-intro-item lx-w100 lx-flex-row">
                                        <div className="">
                                            <div className="intro-title">应届生招聘</div>
                                            <div className="intro-title-sub">查看详情</div>
                                            {/*<p className="intro-time">2021年月1日-2022年8月31日</p>
                                        <p className="intro-des">面向全部在校生开放的不少于两个月的实习项目，生开放的不少于两个实习项目，<br/>少于两我是说明文案介绍占位</p> */}
                                        </div>
                                    </a>
                                    <a href={`/positionList?recruitType=1&projectId=205601`} className="section-intro-top-right section-intro-item lx-w100 lx-flex-row">
                                        <div className="">
                                            <div className="intro-title">博士生招聘</div>
                                            <div className="intro-title-sub">查看详情</div>
                                            {/*<p className="intro-time">2021年月1日-2022年8月31日</p>
                                            <p className="intro-des">面向全部在校生开放的不少于两个月的实习项目，生开放的不少于两个实习项目，<br/>少于两我是说明文案介绍占位</p> */}
                                        </div>
                                    </a>
                                </div>
                                <div className="section-intro-bottom lx-flex-row lx-w100">
                                    <a href={`/positionList?recruitType=12&projectId=202902`} className="section-intro-item  section-intro-bottom-left lx-flex-row">
                                        <div className="">
                                                <div className="intro-title">红旗学院</div>
                                                <div className="intro-title-sub">查看详情</div>
                                            {/* 
                                            <p className="intro-time">2021年月1日-2022年8月31日</p>
                                            <p className="intro-des">面向全部在校生开放的不少于两个月的实<br/>习项目，我是说明文案介绍</p> */}
                                        </div>
                                    </a>
                                    <a href={`/positionList?recruitType=12&projectId=100301`}>
                                        <div className="section-intro-item section-intro-bottom-right lx-flex-column">
                                            <div className="intro-title">实习生</div>
                                            <div className="intro-title-sub">查看详情</div>
                                            {/* <div className="qidai"></div> */}
                                            {/*
                                        <p className="intro-time">2021年月1日-2022年8月31日</p>
                                        <p className="intro-des">面向全部在校生开放的不少于两个月的<br/>实习项目</p> */}
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div className="section-intro-right">
                                <a href={`/positionList?recruitType=1&projectId=205801`}>
                                    <div className="section-intro-right-top section-intro-item lx-flex-column">
                                        <div className="intro-title">“双百”计划</div>
                                        <div className="intro-title-sub">查看详情</div>
                                        {/* <div className="qidai"></div> */}
                                        {/* <div className="intro-title-sub">红旗学院</div>
                                    <p className="intro-time">2021年月1日-2022年8月31日</p>
                                    <p className="intro-des">面向全部在校生开放的不少于两个月的实习项目，<br/>我是说明文案介绍占位</p> */}
                                    </div>
                                </a>
                                <a href={`/positionList?recruitType=1&projectId=203201`}>
                                    <div className="section-intro-right-bottom section-intro-item lx-flex-column lx-w100">
                                        <div className="intro-title">三地招聘</div>
                                        <div className="intro-title-sub">查看详情</div>
                                        {/* <div className="qidai"></div> */}
                                        {/* <div className="intro-title-sub">2022蓝领校招</div>
                                        <p className="intro-time">2021年月1日-2022年8月31日</p>
                                        <p className="intro-des">面向全部在校生开放的不少于两个月的实习项目，生开放<br/>的不少于两个月的实目，少于两是说明文案</p> */}
                                    </div>
                                </a>
                            </div>
                        </div>
                    </section>
                    
                    <section className="section-groceries section-groceries-deley-1">
                        {/* <div className="lx-container lx-h100 lx-flex-row-center"> */}
                            <div className="section-groceries-content lx-h100 lx-flex-row">
                                <div className="section-groceries-content-left lx-flex-row-center">
                                    <div>
                                        {/* <div className="section-groceries-title lx-fz32 lx-text-color-black lx-fwBold lx-mt15 lx-mb65">解忧杂货铺<span className="section-groceries-title-sub">GROUP</span></div> */}
                                        <p className="section-content-tit lx-fz32">
                                            小白也能“零”烦恼
                                        </p>
                                        <Groceries list={groceriesList[0]}></Groceries>
                                    </div>
                                </div>
                                <div className="section-groceries-img lx-flex lx-h100 lx-fz0">
                                    <img className="lx-h100" src={pic01} alt="img" />
                                </div>
                            </div>
                        {/* </div> */}
                    </section>
                
                    <section className="section-groceries section-groceries-deley-2">
                        <div className="section-groceries-content lx-h100 lx-flex-row">
                            <div className="section-groceries-img lx-flex lx-h100 lx-fz0">
                                <img className="lx-h100" src={pic02} alt="img" />
                            </div>
                            <div className="section-groceries-content-left lx-flex-row-center">
                                <div>
                                    <p className="section-content-tit lx-fz32">
                                        着眼当下&nbsp;赋能未来
                                    </p>
                                    <Groceries list={groceriesList[1]}></Groceries>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="section-groceries section-groceries-deley-3">
                        <div className="section-groceries-content lx-h100 lx-flex-row">
                            <div className="section-groceries-content-left lx-flex-row-center">
                                <div>
                                    <p className="section-content-tit lx-fz32">
                                        快乐工作&nbsp;美妙生活
                                    </p>
                                    <Groceries list={groceriesList[2]}></Groceries>
                                </div>
                            </div>
                            <div className="section-groceries-img lx-flex lx-h100 lx-fz0">
                                <img className="lx-h100" src={pic03} alt="img" />
                            </div>
                        </div>
                    </section>
                    <div className="newContentWrap">
                        <div className="wrapTitle">招聘公示</div>
                        {showList && showList.length ?
                            showList.slice(0, 5).map((item, index) => {
                                return <a href={`/recruitmentNewsDetail?index=${index}`} className="wrapItem" key={index}>
                                    <div className="itemLeft">{item.title}</div>
                                    <div className="itemRight">发布时间 {item.times}</div>
                                </a>
                            }) : null}
                        <div className="know-more" onClick={()=>{
                            this.props.history.push("/recruitmentNews")
                        }}>
                            <span>了解更多 &gt;</span>
                        </div>
                    </div>
                </main>
            </>
        );
    }
}
  export default CampusRecruitment;